export const promise = {
    methods: {
        //TODO: 根据id获取承诺书内容
        async getPromiseId(id) {
            let res = await this.$http.get(`/tenant/promise/byId/${id}`);
            return res;
        },
        //TODO：获取全部承诺书
        async getPromise(params) {
            let { pageNum, pageSize, title } = params;
            let res = await this.$http.get("/tenant/promise/list", {
                title: title ?? null,
                pageNum,
                pageSize,
            });

            return res;
        },
        //TODO: 新增承诺书
        async addPromise(data) {
            let res = await this.$http.post("/tenant/promise/add", data);
            if (res.code == 200) {
                this.$message({ message: res.msg, type: "success" });
            } else {
                this.$message.error(res.msg);
            }
        },
        //TODO:修改承诺书
        async upPromise(data) {
            let res = await this.$http.put("/tenant/promise/edit", data);
            if (res.code == 200) {
                this.$message({ message: res.msg, type: "success" });
            } else {
                this.$message.error(res.msg);
            }
        },
        //TODO:删除承诺书
        async delPromise(id) {
            let res = await this.$http.delete(`/tenant/promise/delete/${id}`);
            if (res.code == 200) {
                this.$message({ message: res.msg, type: "success" });
            } else {
                this.$message.error(res.msg);
            }
            return res;
        },
        //TODO: 发送承诺书
        async sendPromise(id) {
            let res = await this.$http.post(`/tenant/promise/send/${id}`);
            if (res.code == 200) {
                this.$message({ message: res.msg, type: "success" });
            } else {
                this.$message.error(res.msg);
            }
            return res;
        },
        //上传文件
        async uploadPromiseFile(file) {
            let res = await this.$http.post("/tenant/file/upload", file, {
                "Content-Type": "multipart/form-data",
            });
            return res;
        },
        //查询承诺书已读未读人员
        async queryIsRead(params) {
            let res = await this.$http.get("/tenant/promise/isRead", params);
            return res;
        },

        async modles(){
            let res = await this.$http.get("/tenant/docTemplate/getModleList");
            return res;
        }
    },
};
